import { asMaybeasy } from '@execonline-inc/structured-maybe';
import { observer } from 'mobx-react';
import { LearningCollection } from '../../../../Types';
import CreateShareUrlStore from '../CreateShareUrlStore';
import NotPublishedBanner from './NotPublishedBanner';
import ShareUrlBannerState from './ShareUrlBannerState';

interface Props {
  learningCollection: LearningCollection;
  store: CreateShareUrlStore;
  publishing: () => void;
}

function Banner({ store, publishing, learningCollection }: Props) {
  const { publishedAt } = learningCollection;
  return asMaybeasy(publishedAt)
    .map(() => (
      <ShareUrlBannerState
        possibleShareUrlCount={learningCollection.possibleShareUrlCount}
        store={store}
      />
    ))
    .getOrElse(() => <NotPublishedBanner name={learningCollection.name} publishing={publishing} />);
}

export default observer(Banner);
